import { media } from 'ia-react-core';
import styled from 'styled-components';

export const StyledDiv = styled.div<{ pt: number; pb: number }>`
  padding-top: ${({ pt }) => pt}px;
  padding-bottom: ${({ pb }) => pb}px;
  padding-left: 16px;
  padding-right: 16px;
  ${media.sm`
  padding-left: 32px;
  padding-right: 32px;
  `}; 
  :not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme?.colors.gray3};
  }
`;
